import { Component, OnInit, AfterViewInit } from '@angular/core';
import { DatasetsService } from '@services/datasets/datasets.service';
import { DatasetDetails } from '@models/dataset';

@Component({
  selector: 'app-loaded-dataset',
  templateUrl: './loaded-dataset.component.html',
  styleUrls: ['./loaded-dataset.component.scss']
})
export class LoadedDatasetComponent implements OnInit {
  // public activeDataSet: DatasetDetails = null;
  public currentPosition: any = '';

  constructor(private datasetsService: DatasetsService) {}

  ngOnInit() {
    this.datasetsService.getCurrentPosition().subscribe(res => {
      this.currentPosition = res;
    });
  }

  public loadALM() {
    console.log('Loading Importer');
  }
}
